export var ExecutorType;
(function (ExecutorType) {
    ExecutorType[ExecutorType["Short"] = 0] = "Short";
    ExecutorType[ExecutorType["Long"] = 1] = "Long";
})(ExecutorType || (ExecutorType = {}));
export var ProposalState;
(function (ProposalState) {
    ProposalState["Pending"] = "Pending";
    ProposalState["Canceled"] = "Canceled";
    ProposalState["Active"] = "Active";
    ProposalState["Failed"] = "Failed";
    ProposalState["Succeeded"] = "Succeeded";
    ProposalState["Queued"] = "Queued";
    ProposalState["Expired"] = "Expired";
    ProposalState["Executed"] = "Executed";
})(ProposalState || (ProposalState = {}));
//# sourceMappingURL=types.js.map